// Copyright © 2020 The Things Network Foundation, The Things Industries B.V.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import React from 'react'

import CodeEditor from '@ttn-lw/components/code-editor'

import PropTypes from '@ttn-lw/lib/prop-types'

const RawEventDetails = React.memo(props => {
  const { className, id, details } = props

  const formattedDetails = JSON.stringify(details, null, 2)

  return (
    <CodeEditor className={className} readOnly name={id} language="json" value={formattedDetails} />
  )
})

RawEventDetails.propTypes = {
  className: PropTypes.string,
  details: PropTypes.shape({}).isRequired,
  id: PropTypes.string.isRequired,
}

RawEventDetails.defaultProps = {
  className: undefined,
}

export default RawEventDetails
